import { z } from "zod";
import { OrderStatus, OrderType } from "./order";
import { PaymentResponseSchema } from "../payment";

export const OrderStatusItemSchema = z.object({
  product_name: z.string(),
  quantity: z.number(),
});

export const OrderStatusResponseSchema = z.object({
  id: z.string(),
  status: z.nativeEnum(OrderStatus),
  type: z.nativeEnum(OrderType),
  payment: PaymentResponseSchema.array(),
  preffered_date: z.string().nullish(),
  preffered_time: z.string().nullish(),
  order_items: OrderStatusItemSchema.array(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type OrderStatusItem = z.infer<typeof OrderStatusItemSchema>;
export type OrderStatusResponse = z.infer<typeof OrderStatusResponseSchema>;
